import type { GetStatusResponse } from '../../../common/types';

export const transformStatusResponse = ({
	currentTimeUtcMillis,
	onCallUntilUtcMillis,
	onCallUntilOffsetMillis,
	isCurrentOnCall,
	isParticipantOfAnyRotation,
	nextOnCallEndUtcMillis,
	nextOnCallEndOffsetMillis,
	nextOnCallStartUtcMillis,
	nextOnCallStartOffsetMillis,
}: GetStatusResponse): {
	currentDate: number;
	currentShiftEnd: number | null;
	currentShiftEndOffset: number;
	isOnCall: boolean;
	isParticipantOfAnyRotation: boolean;
	nextEndDate: number | null;
	nextEndOffset: number;
	nextStartDate: number | null;
	nextStartOffset: number;
} => {
	return {
		currentDate: currentTimeUtcMillis,
		currentShiftEnd: onCallUntilUtcMillis,
		currentShiftEndOffset: onCallUntilOffsetMillis,
		isOnCall: isCurrentOnCall,
		isParticipantOfAnyRotation: isParticipantOfAnyRotation,
		nextEndDate: nextOnCallEndUtcMillis,
		nextEndOffset: nextOnCallEndOffsetMillis,
		nextStartDate: nextOnCallStartUtcMillis,
		nextStartOffset: nextOnCallStartOffsetMillis,
	};
};
